// removed by extract-text-webpack-plugin
module.exports = {"noticeWrapper":"_1LDl5rwCkDHV0tW5CD0PM0","notice":"_3vNJuyzl9QTBwTfTvbM-zT","link":"_2bZssgcSTwYa094McUnMde"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SubscriptionNotice/SubscriptionNotice.mod.css
// module id = 1572
// module chunks = 0